import { createTransaction } from 'features/transactions/api';
import { confirmBid, matchBid } from 'features/bids/api';
import { stripePromise } from 'components/payments/SeditionStripeElements';

import { errorFromException } from 'errors';

const genericErrorMessage =
  'Unable to process card payment, please try a different payment method.';

export const placeBidUsingPaymentMethod = async (bidPublicId: string, paymentMethodId: string) => {
  try {
    const { data: matched, error: matchError } = await matchBid(bidPublicId);
    if (matchError) {
      throw matchError;
    }

    const { data: transaction, error: transactionError } = await createTransaction(
      'bids',
      bidPublicId,
      paymentMethodId,
      matched
        ? {
            confirmationMethod: 'automatic',
            captureMethod: 'manual',
          }
        : {
            confirmationMethod: 'manual',
            captureMethod: 'automatic',
          },
    );

    if (transactionError || !transaction) {
      throw transactionError || genericErrorMessage;
    }

    if (matched) {
      const stripe = await stripePromise;
      if (!stripe) {
        throw 'Unexpected error occurred. Please try again.';
      }

      const { error: stripeError } = await stripe.confirmCardPayment(
        transaction.payment_intent.client_secret,
      );

      if (stripeError) {
        throw stripeError.message || genericErrorMessage;
      }
    }

    const { data: bid, error: bidError } = await confirmBid(bidPublicId);

    if (bidError) {
      throw bidError;
    }

    return { data: bid, error: undefined };
  } catch (e) {
    return errorFromException(e);
  }
};
